import { useTranslation } from '@shared/i18n';
import { useTelegramStatus } from '@features/settings/hooks/useTelegram';
import { useLowStock } from '../hooks/useLowStock';

export function LowStockCard() {
  const { t } = useTranslation();
  const { data: telegramStatus } = useTelegramStatus();
  const { data, isLoading } = useLowStock();

  if (!telegramStatus?.linked) return null;
  if (isLoading) {
    return (
      <div className="card p-6">
        <p className="text-sm text-gray-500">{t('common.loading')}</p>
      </div>
    );
  }
  if (!data?.items?.length) return null;

  return (
    <div className="card p-6">
      <h3 className="text-lg font-medium text-gray-900 mb-4">
        {t('low_stock.title')}{' '}
        <span className="text-sm font-normal text-red-500">({data.items.length})</span>
      </h3>

      <div className="space-y-2">
        {data.items.slice(0, 5).map((item) => (
          <div
            key={item.productId}
            className="flex items-center justify-between py-2 border-b border-gray-100 last:border-0"
          >
            <span className="text-sm text-gray-900 truncate max-w-xs">{item.name}</span>
            <div className="flex items-center gap-2">
              <span className="text-sm font-medium text-red-600">{item.currentStock}</span>
              <span className="text-xs text-gray-400">/ {item.threshold}</span>
            </div>
          </div>
        ))}
      </div>

      {data.items.length > 5 && (
        <p className="text-xs text-gray-400 mt-3">
          {t('low_stock.and_more').replace('${count}', String(data.items.length - 5))}
        </p>
      )}
    </div>
  );
}
